import React from 'react'
import PropTypes from 'prop-types'
import { injectIntl } from 'react-intl'
import { useMutation } from '@apollo/client'
import pick from 'lodash/pick'

import { closeErrorNotifications } from 'helpers/errors'
import { getGoogleAnalyticsTracker } from 'helpers/googleAnalytics'
import { parseBudgetRange } from 'helpers/number'
import { sanitizeFormValues, showSanitizedErrors } from 'components/ContactRequestFormComponents/helpers'

import Form from '../components/Form'

import {
  CREATE_PROJECT_MUTATION,
  CREATE_CONTACT_REQUEST_MUTATION,
} from '../graphql'

import './index.less'

const CreateProject = (props) => {
  const {
    intl,
    initialData,
    provider,
    currentUser,
    onSuccessCallback,
  } = props

  const [createProject, { loading: projectSubmitting }] = useMutation(CREATE_PROJECT_MUTATION)
  const [createContactRequest, { loading: contactRequestSubmitting }] = useMutation(CREATE_CONTACT_REQUEST_MUTATION)

  const submitForm = (formData) => {
    const budgetRange = parseBudgetRange(formData.eventBudget)

    createProject({
      variables: {
        ...pick(formData, ['email', 'roomType', 'requestedDates', 'eventCategoryId', 'cityId']),
        guestCount: parseInt(formData.numberOfPersons),
        budgetMax: budgetRange[1],
        providerId: provider.id,
      },
    }).then((projectResult) => {
      const ga = getGoogleAnalyticsTracker()

      return createContactRequest({
        variables: {
          providerId: provider.id,
          projectId: projectResult.data.createProject.project?.id,
          googleAnalyticsClientId: ga && ga.get('clientId'),
          forNewProject: true,
        },
      })
    }).then(({ data }) => {
      onSuccessCallback(data.createContactRequest.contactRequest)

      return true
    }).catch((errors) => {
      showSanitizedErrors(
        errors.graphQLErrors[0]?.extensions?.errors,
        intl,
      )

      return false
    })
  }

  const isSubmitting = projectSubmitting || contactRequestSubmitting

  const submitFormAction = (values) => {
    closeErrorNotifications()
    submitForm(sanitizeFormValues(values))
  }

  return (
    <div className="contact-request__create-project">
      <Form
        initialData={initialData}
        provider={provider}
        currentUser={currentUser}
        submitForm={submitFormAction}
        isSubmitting={isSubmitting}
      />
    </div>
  )
}

CreateProject.propTypes = {
  intl: PropTypes.object.isRequired,
  initialData: PropTypes.object,
  currentUser: PropTypes.object,
  provider: PropTypes.shape({
    id: PropTypes.string.isRequired,
  }).isRequired,
  onSuccessCallback: PropTypes.func.isRequired,
}

export default injectIntl(CreateProject)
